import { render, staticRenderFns } from "./WelcomeNavigationLink.vue?vue&type=template&id=0657bda6&scoped=true&"
import script from "./WelcomeNavigationLink.vue?vue&type=script&lang=js&"
export * from "./WelcomeNavigationLink.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeNavigationLink.vue?vue&type=style&index=0&id=0657bda6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0657bda6",
  null
  
)

export default component.exports